export default "__VITE_ASSET__fd68797a__"